import { TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { stepSearchBarKeywordAtom } from '~/atoms/no-code-atoms';

export function SearchBar({
  disabled,
  className,
  autoFocus,
}: {
  disabled?: boolean;
  className?: string;
  autoFocus?: boolean;
}) {
  const searchKeyword = useAtomValue(stepSearchBarKeywordAtom.currentValueAtom);
  const setSearchKeywordDebounced = useSetAtom(stepSearchBarKeywordAtom.debouncedValueAtom);

  // clear search text when search bar is closed (unmounted)
  useEffect(() => {
    return () => {
      setSearchKeywordDebounced({ type: 'immediate', value: undefined });
    };
  }, [setSearchKeywordDebounced]);

  return (
    <div className={className}>
      <TextInput
        autoFocus={autoFocus}
        radius="sm"
        size="sm"
        variant="filled"
        leftSection={<IconSearch size={16} />}
        placeholder="Search steps"
        style={{
          input: { fontSize: 30 },
        }}
        value={searchKeyword}
        onChange={(e) => setSearchKeywordDebounced({ type: 'debounce', value: e.target.value })}
        disabled={disabled}
      />
    </div>
  );
}
